
      // Only load the React app if we're not on the Firebase auth handler path
      if (!window.__FIREBASE_AUTH_HANDLER__) {
        import('/src/main.tsx');
      } else {
        // Show a message if we're incorrectly serving the SPA for Firebase auth paths
        // This means Firebase Hosting isn't properly configured for auth
        document.getElementById('root').innerHTML = `
          <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; min-height: 100vh; font-family: system-ui, sans-serif; padding: 20px; text-align: center;">
            <h2 style="margin-bottom: 16px; color: #333;">Authentication Setup Issue</h2>
            <p style="color: #666; max-width: 400px; line-height: 1.5;">
              Firebase auth paths should be handled by Firebase Hosting, not this app.
              Please check that your authDomain in Firebase config is set to your Firebase project's default domain
              (e.g., yourproject.firebaseapp.com), not the custom domain.
            </p>
            <button onclick="window.close()" style="margin-top: 20px; padding: 10px 20px; background: #1a73e8; color: white; border: none; border-radius: 6px; cursor: pointer;">
              Close Window
            </button>
          </div>
        `;
      }
    